import { Component } from '@angular/core';
import { TextboxComponent } from '../../textbox.component';
import { CurrencyPipe, DatePipe } from '@angular/common';

@Component({
  selector: 'next-phone',
  templateUrl: './phone.component.html',
  styleUrls: ['./../../textbox.component.css']
})
export class PhoneComponent extends TextboxComponent {
  constructor (currencyPipe: CurrencyPipe, datePipe: DatePipe) {
    super(currencyPipe, datePipe);
  }

  phonePattern: RegExp = new RegExp(/(^\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$)|(^\d{10}$)/);
}
